<template>
    <div :class="{'-lw-course-contents-slider lw-cols no-gutter align-items-stretch one-row one-row-tl one-row-tp one-row-sl multiple-rows-sp js-course-contents-holder' : componentData.template === 'CourseContentsTemplate21' ||  componentData.template === 'CourseContentsTemplate22'}">
        <template v-if="renderData.course && renderData.course.sections">
            <component
                    v-for="sectionData,sectionTitleId,index in renderData.course.sections"
                    :is="componentData.template"
                    :index="index"
                    :sectionData="sectionData"
                    :authoringMode="false"
                    :courseData="renderData.course"
                    :key="index"
                    :sectionsDisplay="sectionsToggledDisplay"
                    :displayAccessLabel="displayAccessLabel"
                    @set-section-display="setSectionToggledDisplay(sectionData.titleId, ...arguments)"
                    @section-clicked="sectionClicked"
                    @unit-clicked="unitClicked"
            >
            </component>
        </template>
    </div>
</template>
<script>
    import PreviewComponent from "./PreviewComponent";
    import CourseContentsComponent from "../../components/pagesbuilder/dynamic-components/CourseContentsComponent";
    import CourseContentsTemplate1 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate1";
    import CourseContentsTemplate2 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate2";
    import CourseContentsTemplate3 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate3";
    import CourseContentsTemplate4 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate4";
    import CourseContentsTemplate5 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate5";
    import CourseContentsTemplate6 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate6";
    import CourseContentsTemplate7 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate7";
    import CourseContentsTemplate8 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate8";
    import CourseContentsTemplate9 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate9";
    import CourseContentsTemplate10 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate10";
    import CourseContentsTemplate11 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate11";
    import CourseContentsTemplate12 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate12";
    import CourseContentsTemplate13 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate13";
    import CourseContentsTemplate14 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate14";
    import CourseContentsTemplate15 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate15";
    import CourseContentsTemplate16 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate16";
    import CourseContentsTemplate17 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate17";
    import CourseContentsTemplate18 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate18";
    import CourseContentsTemplate19 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate19";
    import CourseContentsTemplate20 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate20";
    import CourseContentsTemplate21 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate21";
    import CourseContentsTemplate22 from "../../author/pagesbuilder/templates/cards/CourseContentsTemplate22";

    import {mapState, mapGetters, mapActions} from 'vuex';

    export default {
        name: "PreviewCourseContentsComponent",
        mixins: [
          PreviewComponent,
          CourseContentsComponent
        ],
        computed: {
            ...mapState([
                'mobileClient',
                'paymentsURL',
            ]),
            ...mapGetters('user',[
                'isLoggedIn',
                'isAdmin',
            ]),
            hasCourseContentsToShow () {
                return this.renderData?.course?.sections && Object.values(this.renderData.course.sections).length > 0;
            },
        },
        methods: {
            ...mapActions('products', [
                'registerUserToCourse',
            ]),
            getUnitRedirectLink (unitData) {
                return window.wwwelopersUrl("pathPlayer", {"coursetitleid": this.myCourseData.titleId, "unit": unitData["id"]}); //video
            },
            sectionClicked (sectionData) {
                // console.log("sectionClicked: " , sectionData);
            },
            unitClicked (payload) {
                payload.event.stopPropagation();
                // console.log("unitClicked: " , payload.unit);
                // console.log("sectionData: " , payload.sectionData);
                // console.log("myCourseData: " , this.myCourseData);
                // return;
                if ( ( this.myCourseData.access == 'private-enroll' && typeof this.myCourseData.me === "undefined" ) ||
                    (   this.myCourseData.access == 'private-enroll' && typeof this.myCourseData.me !== "undefined" &&
                        this.myCourseData.status == "free" && !this.myCourseData.me.registered )                    ||
                    (   this.myCourseData.access == 'private-enroll' && typeof this.myCourseData.me !== "undefined" &&
                        this.myCourseData.status == "paid" && !this.myCourseData.me.premium )

                ) {
                    return ;
                }

                if (!this.isLoggedIn) {

                    // Redirect free courses or units that are free to path player (will trigger signin/signup based on client)
                    if (this.myCourseData.status === "free" || payload.sectionData.access === 'public') {
                        document.location.href = this.getUnitRedirectLink(payload.unit);
                        return;
                    }

                    if (this.myCourseData.status === "paid") {
                        return this.premium();
                    }
                }


                //disable dripped section units for registered/premium users
                if (    ( payload.sectionDripFeedStatus === "next" || payload.sectionDripFeedStatus === "closed")  &&
                        ( !this.myCourseData.me.premium  || !this.myCourseData.me.registered) ) {
                    return;
                }

                //disable soon execept author
                if (payload.sectionData.access === "soon" && !this.isAdmin) {
                    return showMessage("alert", this.$t('course.not_ready'), this.$t('course.not_ready_msg'), [{"name":"OK"}])

                }

                //disable premium sections for non premium users
                if (payload.sectionData.access === "premium" && !this.isAdmin &&  !this.myCourseData.me.premium) {
                    return this.premium();
                }

                //disable free units
                if (payload.sectionData.access === "public" && !this.isAdmin && !this.myCourseData.me.premium && !this.myCourseData.me.registered && this.myCourseData.status === "free") {
                    return this.freemium();
                }


                document.location.href = this.getUnitRedirectLink(payload.unit);
            },
            premium () {
                if (typeof this.mobileClient !=='undefined' && this.mobileClient) {
                    return;
                }

                if (!this.myCourseData.premium) {
                    showMessage("alert", this.$t('course.premium'), this.$t('course.no_access_yet'), [{"name":"OK"}])
                } else {
                    showMessage("alert", this.$t('course.premium'), this.$t('course.no_access_yet')+" "+ this.$t('course.enroll_course'), [{"name": this.$t('course.enroll'),"func": this.buy}, {"name":"Cancel"}])
                }
            },
            freemium () {
                showMessage("alert", this.$t('course.free_register'), this.$t('course.enroll_course'), [{"name":"ok", "func":this.register}, {"name":"cancel"}])
            },
            buy () {
                if (WI) {
                    WI.rec("Buy button clicked in " + this.myCourseData.title.trim(), "courseBuyButton");
                }

                if (!this.paymentsURL) {
                    showMessage("inform", this.$t('course.not_ready'), this.$t('course.not_ready_msg'), [{"name":"OK"}])
                } else {
                    window.location.href= this.paymentsURL + this.myCourseData.titleId;
                }
            },
            register () {
                const courseId = this.myCourseData.id;
                // console.log("register to ; " , courseId)
                this.registerUserToCourse({courseId})
                    .then(({data}) => {
                        if (data.success) {

                            // todo add registration to store

                            // _this.course.me.registered = true;
                            //
                            // if (_this.courseContentObject) {
                            //
                            //     _this.courseContentObject.myCourseData.me.registered = true;
                            //
                            //     if (_this.courseContentObject.dripFeed) {
                            //         _this.courseContentObject.load();
                            //     } else {
                            //         _this.courseContentObject.init();
                            //     }
                            // }
                            //
                            // // todo if on a page with course list we should also show that he has access to the course too
                            // _this.initEnrollZones();
                            // _this.courseBoughtButtons(_this.$wrapper, true);

                            document.location.href = wwwelopersUrl("pathPlayer",{coursetitleid: this.myCourseData.titleId})
                        } else {
                            displayError(data.errors);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        displayError();
                    });

                },
            toggleMySectionVisibility (display) {
                const mySection = this.hasContext('section')[0];
                if (mySection) {
                    const mySectionState = this.findNodeState(mySection.id);
                    mySectionState.myNode.style.display = display ? 'block' : null;
                }
            }
        },
        watch: {
            hasCourseContentsToShow: {
                handler : function (newVal) {
                    this.toggleMySectionVisibility(newVal);
                },
                immediate: true
            }
        },
        components: {
            CourseContentsTemplate1,
            CourseContentsTemplate2,
            CourseContentsTemplate3,
            CourseContentsTemplate4,
            CourseContentsTemplate5,
            CourseContentsTemplate6,
            CourseContentsTemplate7,
            CourseContentsTemplate8,
            CourseContentsTemplate9,
            CourseContentsTemplate10,
            CourseContentsTemplate11,
            CourseContentsTemplate12,
            CourseContentsTemplate13,
            CourseContentsTemplate14,
            CourseContentsTemplate15,
            CourseContentsTemplate16,
            CourseContentsTemplate17,
            CourseContentsTemplate18,
            CourseContentsTemplate19,
            CourseContentsTemplate20,
            CourseContentsTemplate21,
            CourseContentsTemplate22
        }

    }
</script>
